<script lang="ts">
  import { cn } from "$lib/utils";

  export let index: number;
  export let href: string;
  export let isActive: boolean;
</script>

<a
  {href}
  class={cn(
    "flex h-10 items-center justify-center rounded-lg bg-transparent px-4 text-blog-gray-500 dark:text-blog-gray-400",
    isActive && "bg-blog-gray-50 text-blog-gray-1000 dark:bg-blog-gray-950 dark:text-blog-gray-300",
  )}
>
  {index}
</a>
